module.exports = __webpack_public_path__ + "img/language.53feafbc.png";